import PropTypes from 'prop-types';

export function ReviewRow({ label, value }) {
  return (
    <div className='flex items-start justify-between gap-4 border-b border-[#F3F7FB] py-3 last:border-b-0'>
      <span className='shrink-0 text-[13px] text-[#7A9AB0]'>{label}</span>
      <span className='min-w-0 flex-1 break-words text-right text-[13.5px] font-medium leading-5 text-[#0B1929]'>{value || '—'}</span>
    </div>
  );
}

ReviewRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

export function ReviewSection({ title, children, isLast = false, onEdit, editDisabled = false }) {
  return (
    <div className={`rounded-[16px] border border-[#DDE6EF] bg-white ${isLast ? '' : 'mb-3.5'}`}>
      <div className='flex items-center justify-between border-b border-[#EEF3F8] px-4 py-3'>
        <span className='text-[13px] font-semibold text-[#0B1929]'>{title}</span>
        {typeof onEdit === 'function' ? (
          <button
            type='button'
            onClick={onEdit}
            disabled={editDisabled}
            className='text-[13px] font-medium text-[#2E6BAD] hover:underline disabled:cursor-not-allowed disabled:opacity-50'
          >
            Edit
          </button>
        ) : null}
      </div>
      <div className='px-4 py-1'>{children}</div>
    </div>
  );
}

ReviewSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isLast: PropTypes.bool,
  onEdit: PropTypes.func,
  editDisabled: PropTypes.bool,
};

export function ReviewStepShell({ icon, title, subtitle, children, footer }) {
  return (
    <div className='flex w-full justify-center bg-[#EBF4FB] px-4 pt-7 font-sans text-[#0B1929] sm:min-h-screen sm:px-6'>
      <div className='w-full max-w-[540px] sm:mb-24'>
        <div className='rounded-[20px] bg-white px-6 py-8 shadow-[0_4px_32px_rgba(11,25,41,0.08)] sm:px-10 sm:py-9'>
          <div className='mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#EBF4FB] text-[#1E4E80]'>{icon}</div>
          <h1 className='mb-2.5 text-center font-serif text-2xl font-normal leading-[1.25] text-[#0B1929]'>{title}</h1>
          {subtitle ? <p className='mt-2 text-center text-sm leading-6 text-[#4E6F8A]'>{subtitle}</p> : null}
          <div className='mt-7'>{children}</div>
          {footer}
        </div>
      </div>
    </div>
  );
}

ReviewStepShell.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
};

export function DocumentReviewIcon() {
  return (
    <svg width='26' height='26' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
      <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
      <polyline points='14 2 14 8 20 8' />
      <line x1='16' y1='13' x2='8' y2='13' />
      <line x1='16' y1='17' x2='8' y2='17' />
    </svg>
  );
}
